// import CSVExporter from "../Report/Components/CSVExporter";

/**
 * Simple fetch api for components
 * @param {Object} props  - The props will passed into the request
 * @param {string} props.fetchMethod - fetch method POST or GET etc...
 * @param {string} props.apiUrl - The URL to download from. Example: '/ISNApi/UpdateStatus'
 * @param {object}  props.body - Request body will be stringify before sent
 * @param {boolean} props.isReturnBlob -  if true will return res obj to transform to Blob
 * @returns {Prozmise}  Promise object represents the request results
 */

const getHeaders = (isFormData = false) => isFormData ? {
    'token': '33a52a95-71bc-40c2-8587-b6031f7d468f',
    'access-control-allow-origin': '*'
} : {
    'token': '33a52a95-71bc-40c2-8587-b6031f7d468f',
    'Content-Type': 'application/json; charset=utf-8',
    'access-control-allow-origin': '*'
}
const dataFetcher = async ({ apiUrl, fetchMethod = "POST", body=null, isReturnBlob = false }) => {
    // console.log("apiUrl", apiUrl, isFormData(body), getHeaders(isFormData(body)))
    let fetchSettings={
        method: fetchMethod,
        headers: getHeaders(isFormData(body)),
        credentials: "include",
        body: isFormData(body) ? body : JSON.stringify({ ...body })
    };
    if(!body) delete fetchSettings.body;
    const res = await fetch(process.env.REACT_APP_API_URL + apiUrl,fetchSettings )
    if (!res.ok) {
        const message = `An error has occured: ${res.status}`;
        throw new Error(message);
    }
    if (isReturnBlob) return res;
    return await res.json();
}

function isFormData(obj) {
    return obj instanceof FormData;
}

export default dataFetcher;
